<template>
  <div class="resultatsPageTreeViewComponent">
    <div class="tree-menu">
      <div class="label-wrapper cursor-class" >
        <div :style="indent">
          📝
          <span @click="choosePage" :class="node.is_bugged ? 'ml-2 text-danger' : 'ml-2'">
            {{ node.name }}
            <b-badge v-if="node.is_timeout" class="ml-1" pill variant="warning"><v-icon scale="0.7" name="clock"/> Timeout</b-badge>
            <b-badge v-if="localNbDetected > 0" pill variant="primary">{{localNbDetected}}</b-badge>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'resultatsPageTreeViewComponent',
  props: {
    depth: Number,
    node: Object,
    token: String
  },
  data () {
    return {
      localNbDetected: this.node.nb_crawledpage_detected
    }
  },
  computed: {
    indent() {
      return { transform: `translate(${this.depth * 50}px)` }
    },
  },
  watch: {
    'node.nb_crawledpage_detected': function (val) {
      this.localNbDetected = val
    },
  },
  mounted () {
    this.$root.$on('refresh-tree-stats', this.onRefreshTreeStats)
  },
  beforeDestroy () {
    this.$root.$off('refresh-tree-stats', this.onRefreshTreeStats)
  },
  methods: {
    choosePage () {
      this.$emit('choose-page', this.node)
    },
    onRefreshTreeStats ({ pageId, folderId }) {
      if (pageId != null) {
        // Depuis la vue page : uniquement cette page
        if (pageId === this.node.id) {
          this.localNbDetected = 0
        }
      } else if (folderId === this.node.folder) {
        // Depuis la vue dossier (pas de pageId) : toutes les pages du dossier
        this.localNbDetected = 0
      }
    },
  }
}
</script>

<style>
.cursor-class {
  cursor: pointer;
}
</style>
